import date from 'Arch/mixins/DateMixin';

const moment = date.methods;

const storage = localStorage;

function makeName(name = '') {
  return `@backoffice:${name}`;
}

const tokenKey = makeName('token');
const refresKey = makeName('refreshToken');
const userKey = makeName('user');
const userDocument = makeName('document');
const dateTokenKey = makeName('dateTokenValidate');

function getItemLocalStorage(item) {
  return storage.getItem(item);
}

function saveItemLocalStorage(key, item) {
  let savedItem = item;

  if (typeof item !== 'string') {
    savedItem = JSON.stringify(item);
  }
  return storage.setItem(key, savedItem);
}

function getToken() {
  return getItemLocalStorage(tokenKey);
}

function getRefreshToken() {
  return getItemLocalStorage(refresKey);
}

function saveRefreshToken(payload) {
  saveItemLocalStorage(refresKey, payload.refresh_token);
  const token = getRefreshToken();
  if (token !== payload.refresh_token) {
    saveRefreshToken(payload);
  }
}

function saveTokenDate(payload) {
  return saveItemLocalStorage(dateTokenKey, moment.addDateIn(
    moment.now(),
    payload.expires_in,
    'seconds',
  ).format());
}

function getTokenDate() {
  return storage.getItem(dateTokenKey);
}

function saveToken(payload) {
  saveTokenDate(payload);
  return saveItemLocalStorage(tokenKey, payload.access_token);
}

function clearLocalStorage() {
  storage.clear();
}

function saveUser(payload) {
  saveItemLocalStorage(userKey, payload.completeName);
  saveItemLocalStorage(userDocument, payload.username);
}

function getLocalUser() {
  return storage.getItem(userKey);
}

function getLocalUsername() {
  return storage.getItem(userDocument);
}

export {
  getItemLocalStorage,
  getToken,
  saveToken,
  clearLocalStorage,
  getRefreshToken,
  saveRefreshToken,
  saveUser,
  getLocalUser,
  getTokenDate,
  saveItemLocalStorage,
  getLocalUsername,
};
